// Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnInit } from '@angular/core';
import {ISubscription} from '../../../../types/subscription';
import { IIncludedSoftware } from '../products.component';

@Component({
    selector: 'app-bitlocker-sub',
    templateUrl: './bitlocker-sub.component.html',
    styleUrls: ['./bitlocker-sub.component.scss', '../products.component.scss'],
    standalone: false
})
export class BitlockerSubComponent implements OnInit{
  @Input() subscription: ISubscription;
  @Input() title: string;
  data: IIncludedSoftware[] = []
  columnsToDisplay = ['productName', 'assignedLicenses', 'purchasedQuantity'];

  ngOnInit() {
    this.data = [
      {
        productName: "Data Defense",
        assignedLicenses: this.subscription.used,
        licensesApply: true,
        purchasedQuantity: this.subscription.count,
        hasEndpoints: false,
        canAssign: false,
        hiddenForPartners: [],
      },
    ];
  }

}
